import { render, staticRenderFns } from "./DetailsPlateLayout.vue?vue&type=template&id=6aa824b8&"
import script from "./DetailsPlateLayout.vue?vue&type=script&lang=js&"
export * from "./DetailsPlateLayout.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPlateLayout.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports